import { ChangeEvent, ReactElement, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useAsyncFetch } from "../../system/useFetch";
import SaveIcon from "@mui/icons-material/Save";


interface IProps {
  open: boolean;
  closed: () => void;
}

const TransferToolDialog = ({ open, closed }: IProps): ReactElement => {
  const [ limit, setLimit ] = useState(1000);
  const [ pages, setPages ] = useState(100);
  const [ historyID, setHistoryID ] = useState(0);
  const [ executeRequest, { loading } ] = useAsyncFetch();

  const onchangeLimit = (event: ChangeEvent<HTMLInputElement>) => setLimit(parseInt(event.target.value, 10));
  const onchangePages = (event: ChangeEvent<HTMLInputElement>) => setPages(parseInt(event.target.value, 10));
  const onchangeHistoryID = (event: ChangeEvent<HTMLInputElement>) => setHistoryID(parseInt(event.target.value, 10));

  const onExecute = () => {
    executeRequest({
      module: "system",
      query: "transferData",
      payload: {
        limit,
        pages,
        historyID
      }
    }).then((response: any) => {
      if (response.status) {
        setHistoryID(response.historyID);
      }
    });
  };

  return (
    <Dialog onClose={closed} aria-labelledby="customized-dialog-title" open={open} maxWidth={"lg"}>

      <DialogTitle id="customized-dialog-title">
        TOOL
      </DialogTitle>

      <DialogContent dividers={true} style={{ width: 800 }}>
        <TextField variant="outlined" value={limit} onChange={onchangeLimit} disabled={loading} />
        <TextField variant="outlined" value={pages} onChange={onchangePages} disabled={loading} />
        <TextField variant="outlined" value={historyID} onChange={onchangeHistoryID} disabled={loading} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onExecute} variant="contained" color="primary" disabled={loading} startIcon={<SaveIcon />}>
          Update
        </Button>
        <Button onClick={closed} variant="contained" color="secondary" disabled={loading} startIcon={<CloseIcon />}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransferToolDialog;
